import React from "react";
import { useSelector } from "react-redux";
import { Table } from "react-bootstrap";
import { selectCustomOptions } from "../../../redux/selectors";
import { selectApiStatus } from "../../../redux/slices/apiStatusSlice"; 

const CustomOptions = () => {
    const customOptionsList = useSelector(selectCustomOptions); // Assuming the selector is the same
    const sectionName = "customOptions";

    console.log("CustomOptionsList:", customOptionsList); // Debugging line

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
    };

    const rowStyle = { backgroundColor: '#f9f9f9', padding: '10px' };
    const labelStyle = { fontWeight: 'bold' };

    const hasCustomOptions = customOptionsList.some(option => (option.PartName || option.Description) && option.ListPrice);

    const apiStatus = useSelector(selectApiStatus); // Fetch API status from Redux
    const loading = apiStatus[sectionName] !== "success"; // Determine loading state based on API status

    if (loading) {
        return (
          <div className="d-flex justify-content-center align-items-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ); // Show loading spinner
      }

    return (
        <div className="container">
            {hasCustomOptions ? (
                <Table striped bordered hover>
                    <tbody>
                        {customOptionsList.map((customOptionItem, index) => (
                            <tr key={index} style={rowStyle}>
                                <td colSpan="2">
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                        <div><span style={labelStyle}>Name:</span> {customOptionItem.PartName}</div>
                                        <div><span style={labelStyle}>List Price:</span> {formatCurrency(customOptionItem.ListPrice)}</div>
                                    </div>
                                    <div>
                                        <strong>Description:</strong>
                                        <div>{customOptionItem.Description}</div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            ) : (
                <div>No custom options available</div>
            )}
        </div>
    );
};

export default CustomOptions;